module.exports = __webpack_public_path__ + "img/ring_skip_0_null_null@3x.cf8bd6fe.png";